import store from '@/store'

export default [
  {
    path: '/user/info/:id',
    name: 'UserDetail',
    component: () => import('@/views/Users/UserDetail.vue'),
    children: [
      {
        path: 'personal',
        name: 'UserDetail_personalTab',
        component: () => import('@/components/page/user/UserDetail_personalTab.vue')
      },
      {
        path: 'calendar',
        name: 'UserDetail_calendarTab',
        component: () => import('@/components/page/user/UserDetail_calendarTab.vue')
      },
      {
        path: 'hours',
        name: 'UserDetail_hoursTab',
        component: () => import('@/components/page/user/UserDetail_hoursTab.vue')
      }
    ],
    async beforeEnter (to, from, next) {
      if (store.getters.rightsUsersRead) {
        next()
      } else {
        next({ name: 'Home' })
      }
    }
  }
]
